/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-12 10:27:50
 *
 *******************************************************/
//@flow

import React from 'react';
import { Checkbox, InlineError } from '@shopify/polaris';
import { Tooltip, Icon } from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';

const RenderLabelTooltip = (props: Object) => {
  return (
    <React.Fragment>
      {props.label ? (
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <label style={{ display: 'inline' }} className="default-text-style Polaris-Label__Text">
              {props.label}
              {props.tooltip ? (
                <span
                  className={`tooltip ${props.tooltip.length > 100 ? 'long-tooltip' : ''}`}
                  style={{ marginTop: '4px' }}>
                  <Tooltip
                    content={<span className="tooltipContent"> {props.tooltip}</span>}
                    preferredPosition="above">
                    <Icon source={QuestionMarkMajor} color="base" />
                  </Tooltip>
                </span>
              ) : (
                ''
              )}
            </label>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export const RenderCheckboxToolTip = (field: Object) => {
  return (
    <div>
      <Checkbox
        id={field.input.name}
        checked={field.input.value ? true : false}
        onChange={field.input.onChange}
        label={<RenderLabelTooltip label={field.label} tooltip={field.tooltip} />}
        disabled={field.isDisabled ? true : false}
        {...field.anotherProps}
      />
      {field.meta.error ? <InlineError message={field.meta.error} /> : ''}
    </div>
  );
};
